<template>
  <el-dialog
    v-drag
    title="新增"
    :visible.sync="dialogVisible"
    width="600px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <el-form
        ref="form"
        class="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item prop="clearanceMode" label="清关模式">
              <el-select v-model="form.clearanceMode" style="width: 100%;" clearable placeholder="请选择清关模式">
                <el-option
                  v-for="item in clearanceModesOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="systemFileId">
              <span slot="label">
                上传文件
              </span>
              <div class="upload">
                <el-upload
                  class="upload-demo"
                  style="margin-left: 16px"
                  :action="`api/InvoiceTemplate/SaveSupplierTemplate?supplierId=${supplierId}&clearanceMode=${form.clearanceMode}`"
                  :headers="headers"
                  :file-list="fileList"
                  :show-file-list="false"
                  :on-success="onSuccess"
                  :on-error="onError"
                  :before-upload="beforeUpload"
                  accept=".xlsx"
                >
                  <el-button class="btn" size="small">
                    <svg-icon iconClass="upload" className="icon" />
                    上传预报模板
                  </el-button>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    clearanceModesOptions: {
        type: Array,
        default: () => []
    },
    supplierId: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      form: {
        clearanceMode: ''
      },
      rules: {
        clearanceMode: [
          { required: true, message: '请选择清关模式', trigger: 'change' }
        ]
      },
      fileList: [],
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) },
      loading: false
    }
  },
  methods: {
    cancel() {
      this.$refs['form'].resetFields()
      this.fileList = []
      this.$emit('cancel')
    },
    onSuccess(res) {
        this.loading = false
      if (res.success) {
        this.$message.success('上传成功')
        this.$emit('ok')
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    onError(error) {
        this.loading = false
      this.$message.error('上传失败')
      console.error(error)
    },
    beforeUpload() {
        this.loading = true
      if (!this.form.clearanceMode) {
        this.$message.error('请选择清关模式')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 80px);
  margin: 0 auto;
  &:deep(.el-col:nth-child(even)) {
    display: flex;
    justify-content: flex-end;
  }
  .upload {
    width: 320px;
    height: 100px;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    width: 160px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid  rgb(18,88,188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    .icon {
      font-size: 24px;
      vertical-align: middle;
    }
  }
  .fileList {
    width: 300px;
    height: 40px;
    padding: 12px 10px;
    margin-top: 10px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    display: flex;
    .file {
      display: flex;
      flex: 1;
    }
    .opt {
      line-height: 40px;
      font-size: 20px;
      color: #cdcdcd;
      cursor: pointer;
    }
  }
  .file-item {
    text-indent: 10px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
  }
  .fileName {
    color: #666666;
  }
  .fileSize {
    font-size: 12px;
    color: #999999;
  }
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
